module.exports = __webpack_public_path__ + "static/pn-250c320b86c35d0dd6a9038c6f7039b4.svg";